import { Injectable } from '@angular/core';
import { CookieService, CookieOptions } from 'angular2-cookie/core';

@Injectable()
export class CookieManagerService {

  /**
   * CookieManagerService constructor
   * depenedecy Injectable
   * @param {CookieService} cookieService
   */
  constructor(private cookieService: CookieService) { }

  /**
   * object or nonOject value set in cookie 
   * @param {string} key
   * @param {string} value
   * @param {boolean} isObject
   * @param {number} exdays
   */
  setCookie(key:string , value:string, isObject:boolean, exdays:number){
    exdays = typeof exdays !== 'undefined' ? exdays : 1;
    var exDuration= new Date();
    exDuration.setTime(exDuration.getTime() + (exdays*24*60*60*1000));
    // isObject ? this.cookieService.putObject(key, value, exDuration) : this.cookieService.put(key, value, exDuration);
  }

  /**
   * get object in cookie 
   * @param {string} key
   * @param {boolean} isObject
   */
  getCookie(key: string, isObject:boolean): any{
    return isObject ? this.cookieService.getObject(key) : this.cookieService.get(key) ? 
      this.cookieService.get(key).toString() : '';
  }

  /**
   * remove cookie 
   * @param {string} key
   */
  removeCookie(key:string){
    this.cookieService.remove(key);
  }

  /**
   * remove All cookie 
   * @param {string} key
   */
  removeAllCookie(){
    this.cookieService.removeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/cookie-manager.service.ts